module.exports = __webpack_public_path__ + "media/images/about-slider-img-02-74696601219cbeb7db6a651b5ddf4a49.jpg";